import React from "react";

const FormModal = ({ isOpen, onClose, title = "Modal", children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white w-full max-w-xl mx-auto mt-10 mb-10 max-h-[95vh] shadow-lg flex flex-col">
        <div className="flex bg-gradient-to-r from-lime-500 to-sky-500 justify-between items-center px-6 py-4 flex-shrink-0">
          <h2 className="text-lg uppercase text-white font-bold">{title}</h2>
          <button onClick={onClose} className="text-white text-xl">
            ×
          </button>
        </div>
        <div className="p-8 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
};

export default FormModal;
